import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Input, notification, Divider } from 'antd';
import { push } from 'connected-react-router';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

// Local
import Text from 'components/Text';
import { post } from 'library/endpoints';

/**
 * Reset
 * @param {*} props 
 * @returns 
 */
const Reset = (props) => {
  useEffect(() => {
    if (props.auth.token) {
      props.push('/')
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    if (props.auth.token) {
      props.push('/')
    }
  }, [props.auth]) // eslint-disable-line

  const [form, setForm] = useState({
    password_confirm: null,
    password: null,
  })

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length > 7 && form.password_confirm !== form.password) {
      // Error
      notification.error({
        message: 'Erreur',
        description: props.t('Admin.Auth.Reset.SubmitError', 'Erreur lors de la soumission de vos informations')
      }); 
    } else {
      await post(`/frontend/auth/reset`, {...form, resetToken: props.match.params.token});
      props.push('/')
    }
  }
  
  return (
    <>
      <form style={{ width: 400, margin: 'auto', marginTop: 40 }} onSubmit={handleOnSubmit}>
        <h1>{props.t('Admin.Auth.Reset.Title', 'Réinitialiser votre mot de passe')}</h1>
        {
          form.password && form.password.length < 8 && (
            <Text color="red">{props.t('Admin.Auth.Reset.PasswordLengthError', 'Votre mot de passe doit contenir au moins 8 caractères')}</Text>            
          )
        }

        {
          form.password && form.password.length > 7 && form.password !== form.password_confirm && (
            <Text color="red">{props.t('Admin.Auth.Reset.PasswordConfirm', 'Vos deux mots de passe ne sont pas identiques')}</Text>            
          )
        }

        <div style={{ height: 20 }} />

        {props.t('Admin.Auth.Reset.Password', 'Mot de passe')}
        <Input.Password type="password" placeholder='password' onChange={(e) => setForm({...form, password: e.target.value})} minLength={8}/>

        <div style={{ height: 20 }} />

        {props.t('Admin.Auth.Reset.PasswordConfirm', 'Confirmation de mot de passe')}

        <Input.Password type="password" placeholder='password' onChange={(e) => setForm({...form, password_confirm: e.target.value})} minLength={8}/>

        <div style={{ height: 20 }} />

        
        <Button 
          type="primary" 
          htmlType="submit" 
          disabled={!form.password || (form.password !== form.password_confirm) || form.password.length < 8}
        >
          {props.t('Admin.Auth.Reset.Button', 'Réinitialiser')}
        </Button>
      </form>

      <Divider>ou</Divider>
      
      <Text align="center">
        <Link to={``}>{props.t('Admin.Auth.Reset.LoginLink', `S'identifier`)}</Link>
      </Text>
    </>
  )
}

const stateToProps = state => ({
  auth: state.auth,
})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Reset));